import { FormControlLabel, Switch, SwitchProps, styled } from '@mui/material';
import { ChangeEvent, ReactNode } from 'react';

const IOSSwitch = styled((props: SwitchProps) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiFormControlLabel-root': {
    margin: 0,
  },
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(48, 137, 60, 1)' : 'rgba(48, 137, 60, 1)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: 'rgba(48, 137, 60, 1)',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

interface SwitchCustomProps {
  onChange: (isChecked: boolean) => void;
  isChecked: boolean;
  className?: string;
  disabled?: boolean;
  label?: ReactNode;
}

function CustomSwitch({ onChange, isChecked, className, label, disabled }: SwitchCustomProps) {
  const handleSwitchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    onChange(isChecked);
  };

  return (
    <FormControlLabel
      style={{ margin: 0 }}
      className={className}
      control={<IOSSwitch checked={isChecked} onChange={handleSwitchChange} disabled={disabled} />}
      label={label}
    />
  );
}

export default CustomSwitch;
